// extracted by mini-css-extract-plugin
export default {"dashboardAction":"IpSecurityView_dashboardAction__4BsSD","dashboardRow":"IpSecurityView_dashboardRow__td2IF","smallTableHeading":"IpSecurityView_smallTableHeading__11yYE"};